/**
 * @generated SignedSource<<1813725394b6fcc83d0520eadd8a4cb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConfirmAccountInfo_referralCheckQuery$variables = {
  email: string;
};
export type ConfirmAccountInfo_referralCheckQuery$data = {
  readonly availableEmail: boolean | null;
};
export type ConfirmAccountInfo_referralCheckQuery = {
  response: ConfirmAccountInfo_referralCheckQuery$data;
  variables: ConfirmAccountInfo_referralCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ScalarField",
    "name": "availableEmail",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfirmAccountInfo_referralCheckQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfirmAccountInfo_referralCheckQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9a66fd1e5c2179234030f530d09bb765",
    "id": null,
    "metadata": {},
    "name": "ConfirmAccountInfo_referralCheckQuery",
    "operationKind": "query",
    "text": "query ConfirmAccountInfo_referralCheckQuery(\n  $email: String!\n) {\n  availableEmail(email: $email)\n}\n"
  }
};
})();

(node as any).hash = "6dbb68ea0783f5eb66708160af2559fb";

export default node;
